module.exports = __webpack_public_path__ + "static/media/tensorflow.e9e39158.svg";